import {
	ADMINADDORUPDATECURRENCY_SUCCESS,
	ADMINADDORUPDATECURRENCY_FAILED,
	RESET_ADMINADDORUPDATECURRENCY,
	LOADING_ADMINADDORUPDATECURRENCY,
	NETWORK_ERROR_ADMINADDORUPDATECURRENCY
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminAddOrUpdateCurrency = () => {
	return { type: RESET_ADMINADDORUPDATECURRENCY };
};

const adminAddOrUpdateCurrency =
	(userData, authTokenIs) => async (dispatch) => {
		dispatch({ type: LOADING_ADMINADDORUPDATECURRENCY });
		await adminServices
			.post("AddOrUpdateCurrency", userData, { headers: { AuthToken: authTokenIs } })
			.then((res) => {
				switch (res.data.status) {
					case "success":
						dispatch(adminAddOrUpdateCurrencysuccess(res.data));
						break;
					default:
						dispatch(adminAddOrUpdateCurrencyFailed(res.data));
						break;
				}
			})
			.catch((err) => {
				dispatch({
					type: NETWORK_ERROR_ADMINADDORUPDATECURRENCY,
					payload: err
				});
			});
	};
function adminAddOrUpdateCurrencysuccess(data) {
	return {
		type: ADMINADDORUPDATECURRENCY_SUCCESS,
		payload: data
	};
}
function adminAddOrUpdateCurrencyFailed(data) {
	return {
		type: ADMINADDORUPDATECURRENCY_FAILED,
		payload: data
	};
}

export { resetAdminAddOrUpdateCurrency, adminAddOrUpdateCurrency };
